export default __webpack_public_path__ + "static/media/whole-screenshot.a016b846.png";